export default "__VITE_ASSET__pNmnSMjb__"